<!-- @format -->

<radar-chart>
  <slot></slot>
  
  <script>
    import { RadarChart } from "@model/radar-chart.js";

    export default {
      onMounted(props, state) {
        this.onUpdated(props, state);
      },
      onUpdated(props, state) {
        let width =
          typeof props.width !== "undefined" ? Number(props.width) : 250;
        let height =
          typeof props.height !== "undefined" ? Number(props.height) : 250;
        let data = typeof props.data !== "undefined" ? props.data : [];

        const maxValue = data.reduce(
          (acc, cur) => (cur.value < acc ? acc : cur.value),
          0
        );

        if (data.length) {
          RadarChart.draw(this.root, data, {
            w: width - 160,
            h: height - 160,
            maxValue: maxValue,
            levels: 6,
            ExtraWidthX: 160,
            ExtraWidthY: 60,
            indicator: false,
          });
        }
      },
    };
  </script>
</radar-chart>
